import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  inject,
} from '@angular/core';
import { AvatarService } from '../../../services/avatar.service';

@Component({
  selector: 'adf-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent implements OnChanges, OnDestroy {
  private readonly _avatarService = inject(AvatarService);
  private readonly _cdr = inject(ChangeDetectorRef);

  @Input() name: string | null = null;
  @Input() size = 24;
  @Input() email: string | null = null;
  @Input() self = false;

  avatarUrl: string | null = null;
  showInitials = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['email'] || changes['self']) {
      this._loadAvatar();
    }
  }

  ngOnDestroy(): void {
    this._revokeAvatarUrl();
  }

  getInitials(): string {
    if (!this.name) return '?';
    return this.name
      .split(' ')
      .slice(0, 2)
      .map((part) => part[0])
      .join('')
      .toUpperCase();
  }

  onAvatarError() {
    this._fallbackToInitials();
  }

  private _loadAvatar() {
    this._revokeAvatarUrl();
    this.showInitials = true;

    if (!this.self && !this.email) return;

    const avatar$ = this.self ? this._avatarService.getMyAvatar() : this._avatarService.getEntraIDAvatar(this.email!);

    avatar$.then((url) => {
      if (url) {
        this.avatarUrl = url;
        this.showInitials = false;
      } else {
        this._fallbackToInitials();
      }
      this._cdr.markForCheck();
    });
  }

  private _fallbackToInitials() {
    this.showInitials = true;
    this._cdr.markForCheck();
  }

  private _revokeAvatarUrl(): void {
    if (this.avatarUrl) {
      URL.revokeObjectURL(this.avatarUrl);
    }
    this.avatarUrl = null;
  }
}
